import * as Yup from 'yup';
import { POLICY_PATTERN } from '../../constants/patterns';

const searchApplicant = Yup.object().shape(
  {
    pnum: Yup.string()
      .nullable()
      .min(3, 'searchApplicantErrors.passportNumMin')
      .required('validationErrors.isRequired'),
    bdate: Yup.date()
      .nullable()
      .required('validationErrors.isRequired'),
    ssn: Yup.string().when(['policy'], {
      is: (policy) => !policy,
      then: Yup.string()
        .min(3, 'searchApplicantErrors.passportNumMin')
        .test('ssn', 'searchApplicantErrors.onlyNums', (value) => (value ? /^\d*$/.test(value) : true))
        .required('searchApplicantErrors.ssnOrPolicyRequired'),
      otherwise: Yup.string()
        .test('ssn', 'searchApplicantErrors.passportNumMin', (value) => (value ? value.length === 0 || value.length >= 3 : true))
        .test('ssn', 'searchApplicantErrors.onlyNums', (value) => (value ? /^\d*$/.test(value) : true)),
    }),
    policy: Yup.string().when(['ssn'], {
      is: (ssn) => !ssn,
      then: Yup.string()
        .matches(POLICY_PATTERN, 'searchApplicantErrors.policyPattern')
        .required('searchApplicantErrors.policyOrSsnRequired'),
      otherwise: Yup.string().test(
        'policy',
        'searchApplicantErrors.policyPattern',
        (value) => (value ? POLICY_PATTERN.test(value) : true),
      ),
    }),
  },
  [['pnum', 'bdate'], ['ssn', 'policy']],
);

export default searchApplicant;
